import { RootState } from '../store';

export const getDesignElements = (state: RootState) => state.brandElements.designElements;
export const getDesignElementsFonts = (state: RootState) =>
    state.brandElements.designElements?.fonts;
export const getDesignElementsColors = (state: RootState) =>
    state.brandElements.designElements?.colors;
